import Dropdown from 'react-bootstrap/Dropdown';
import React from "react";

const DropdownMenu = ({ titleName, children }) => {
  return (
    <Dropdown style={{display: 'inline-block', margin: 2 + "px"}}>
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        {titleName}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {/* <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
        {children}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropdownMenu;